<template>
  <!-- Program tabs above the account selector of the POP team accounts: All / POP Authority /
       White Glove / Other, each with its number of accounts -->
  <div class="account-program-tabs" role="tablist" aria-label="Filter accounts by program">
    <button
      v-for="tab in tabs"
      :key="tab.key"
      type="button"
      role="tab"
      class="account-program-tabs__tab"
      :class="{ 'is-active': tab.key === value }"
      :aria-selected="tab.key === value ? 'true' : 'false'"
      @click="$emit('input', tab.key)"
    >
      {{ tab.label }}
      <span class="account-program-tabs__count">{{ tab.count }}</span>
    </button>
  </div>
</template>

<script>
import { ACCOUNT_PROGRAM_ALL, ACCOUNT_PROGRAM_FILTERS, accountProgramCounts } from '@/utils/accountPrograms'

/**
 * v-model: the selected filter key (utils/accountPrograms). The parent filters its own list with
 * filterRelationsByProgram; this component only shows the tabs and their counts.
 */
export default {
  name: 'AccountProgramTabs',
  props: {
    value: { type: String, default: ACCOUNT_PROGRAM_ALL },
    /** user.ownerAccounts: the sub-account relations the session user has access to. */
    relations: { type: Array, default: () => [] },
  },
  computed: {
    tabs () {
      const counts = accountProgramCounts(this.relations)
      return ACCOUNT_PROGRAM_FILTERS.map((tab) => ({ ...tab, count: counts[tab.key] || 0 }))
    },
  },
}
</script>

<style lang="scss" scoped>
.account-program-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 18px;
  margin-bottom: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);

  &__tab {
    appearance: none;
    background: none;
    border: none;
    border-bottom: 2px solid transparent;
    margin-bottom: -1px;
    padding: 6px 2px 8px;
    font: inherit;
    font-size: 0.95rem;
    font-weight: 600;
    color: var(--v-mainColor-base);
    opacity: 0.65;
    cursor: pointer;

    &:hover,
    &:focus-visible {
      opacity: 1;
    }

    &.is-active {
      opacity: 1;
      border-bottom-color: var(--v-profileAnchorColor-base);
    }
  }

  &__count {
    margin-left: 4px;
    font-size: 0.8rem;
    font-weight: 500;
    opacity: 0.75;
  }
}
</style>
